import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "flex justify-center gap-2" };
var _hoisted_2 = { class: "flex justify-center gap-2" };
var _hoisted_3 = { class: "flex justify-center gap-2" };
import BaseInput from "../components/BaseInput.vue";
import BaseOutput from "../components/BaseOutput.vue";
import BaseButtons from "../components/BaseButtons.vue";
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'gocceMilillitriCalculator',
    setup: function (__props) {
        var contenutoSoluzione = ref();
        var volumeSoluzione = ref();
        var posologia = ref();
        var gocceMillilitro = ref();
        var mililitri = ref("...");
        var numero = ref("...");
        var contenutoSoluzioneValid = ref("");
        var volumeSoluzioneValid = ref("");
        var posologiaValid = ref("");
        var gocceMillilitroValid = ref("");
        function calculator() {
            contenutoSoluzione.value = (isNaN(contenutoSoluzione.value) || contenutoSoluzione.value == 0) ? 1 : contenutoSoluzione.value;
            volumeSoluzione.value = (isNaN(volumeSoluzione.value) || volumeSoluzione.value == 0) ? 1 : volumeSoluzione.value;
            posologia.value = (isNaN(posologia.value) || posologia.value == 0) ? 1 : posologia.value;
            gocceMillilitro.value = (isNaN(gocceMillilitro.value) || gocceMillilitro.value == 0) ? 1 : gocceMillilitro.value;
            var concSol = contenutoSoluzione.value / volumeSoluzione.value;
            var mlDaSomm = posologia.value / concSol;
            mililitri.value = mlDaSomm;
            numero.value = mlDaSomm * gocceMillilitro.value;
        }
        function eraser(field) {
            field.value = "";
        }
        function resetForm() {
            // Cancellazione valori inseriti
            eraser(contenutoSoluzione);
            eraser(volumeSoluzione);
            eraser(posologia);
            eraser(gocceMillilitro);
            // Cancellazione valori calcolati
            mililitri.value = "...";
            numero.value = "...";
            // Cancellazione validatori
            eraser(contenutoSoluzioneValid);
            eraser(volumeSoluzioneValid);
            eraser(posologiaValid);
            eraser(gocceMillilitroValid);
        }
        function checkInputValidity() {
            if (contenutoSoluzione.value < 1 || contenutoSoluzione.value > 10) {
                contenutoSoluzioneValid.value =
                    "Controlla il valore inserito. Il valore deve essere compreso tra 1 e 10.";
                if (contenutoSoluzione.value > 50) {
                    contenutoSoluzioneValid.value =
                        "Controlla il valore inserito.Il valore deve essere compreso tra 1 e 10." + " Le soluzioni non contengono quasi mai oltre 50 mg di principio attivo";
                }
                else {
                    contenutoSoluzioneValid.value = "Inserisci un valore valido per il contenuto della soluzione. Il valore deve essere compreso tra 1 e 10.";
                }
            }
            else {
                eraser(contenutoSoluzioneValid);
            }
            if (volumeSoluzione.value < 1 || volumeSoluzione.value > 10) {
                volumeSoluzioneValid.value =
                    "Controlla il valore inserito. Il valore deve essere compreso tra 1 e 10.";
                if (volumeSoluzione.value > 100) {
                    volumeSoluzioneValid.value =
                        "Controlla il valore inserito. Il valore deve essere compreso tra 1 e 10." + " I flaconi non contengono quasi mai oltre 100 ml di soluzione";
                }
                else {
                    volumeSoluzioneValid.value = "Controlla il valore inserito. Il valore deve essere compreso tra 1 e 10.";
                }
            }
            else {
                eraser(volumeSoluzioneValid);
            }
            if (posologia.value < 1 || posologia.value > 10) {
                posologiaValid.value =
                    "Controlla il valore inserito. Il valore deve essere compreso tra 1 e 10.";
                if (posologia.value > 10) {
                    posologiaValid.value =
                        "Controlla il valore inserito. Il valore deve essere compreso tra 1 e 10." + " La posologia non è quasi mai superiore a 10 mg.";
                }
                else {
                    posologiaValid.value = "Controlla il valore inserito. Il valore deve essere compreso tra 1 e 10.";
                }
            }
            else {
                eraser(posologiaValid);
            }
            if (gocceMillilitro.value < 1 || gocceMillilitro.value > 100) {
                gocceMillilitroValid.value =
                    "Controlla il valore inserito. Il valore deve essere compreso tra 1 e 100.";
                if (gocceMillilitro.value > 50) {
                    gocceMillilitroValid.value =
                        "Controlla il valore inserito. Il valore deve essere compreso tra 1 e 100." + " Le gocce contenute in un millilitro quasi mai sono maggiori di 50.";
                }
                else {
                    gocceMillilitroValid.value = "Controlla il valore inserito. Il valore deve essere compreso tra 1 e 100.";
                }
            }
            else {
                eraser(gocceMillilitroValid);
            }
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", null, [
                        _createVNode(BaseInput, {
                            label: _ctx.$t('Contenuto Soluzione (mg)'),
                            type: "number",
                            placeholder: "1",
                            modelValue: _unref(contenutoSoluzione),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(contenutoSoluzione) ? (contenutoSoluzione).value = $event : contenutoSoluzione = $event); }),
                            onValidateInput: checkInputValidity,
                            isInputValid: _unref(contenutoSoluzioneValid)
                        }, null, 8, ["label", "modelValue", "isInputValid"]),
                        _createVNode(BaseInput, {
                            label: _ctx.$t('Volume Soluzione (ml)'),
                            type: "number",
                            placeholder: "1",
                            modelValue: _unref(volumeSoluzione),
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return (_isRef(volumeSoluzione) ? (volumeSoluzione).value = $event : volumeSoluzione = $event); }),
                            onValidateInput: checkInputValidity,
                            isInputValid: _unref(volumeSoluzioneValid)
                        }, null, 8, ["label", "modelValue", "isInputValid"])
                    ]),
                    _createElementVNode("div", null, [
                        _createVNode(BaseInput, {
                            label: _ctx.$t('Posologia (mg)'),
                            type: "number",
                            placeholder: "1",
                            modelValue: _unref(posologia),
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return (_isRef(posologia) ? (posologia).value = $event : posologia = $event); }),
                            onValidateInput: checkInputValidity,
                            isInputValid: _unref(posologiaValid)
                        }, null, 8, ["label", "modelValue", "isInputValid"]),
                        _createVNode(BaseInput, {
                            label: _ctx.$t('Gocce per Millilitro'),
                            type: "number",
                            placeholder: "1",
                            modelValue: _unref(gocceMillilitro),
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return (_isRef(gocceMillilitro) ? (gocceMillilitro).value = $event : gocceMillilitro = $event); }),
                            onValidateInput: checkInputValidity,
                            isInputValid: _unref(gocceMillilitroValid)
                        }, null, 8, ["label", "modelValue", "isInputValid"])
                    ])
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(BaseButtons, {
                        onClearForm: resetForm,
                        onCalculate: calculator,
                        hiddenSalvaButton: ""
                    })
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(BaseOutput, {
                        class: "flex text-sm basecolor-mr",
                        label: _ctx.$t('Millilitri'),
                        key: "number",
                        result: _unref(mililitri),
                        unit: "ml"
                    }, null, 8, ["label", "result"]),
                    _createVNode(BaseOutput, {
                        class: "flex text-sm basecolor-mr",
                        label: _ctx.$t('Numero'),
                        key: "number",
                        result: _unref(numero),
                        unit: "gocce"
                    }, null, 8, ["label", "result"])
                ])
            ], 64));
        };
    }
});
